

export class CommonUtility {

  constructor(){}

  //Function to create Hash Map from Array
  createMapFromList(myList){
    let myMap = new Map<string, string>();
    if(myList != undefined){
      for(let prop in myList){
        myMap.set(myList[prop].value , myList[prop].name);
      }
    }
    return myMap;
  }

  //Function to create native Hash Map from Array
  createNativeMapFromList(myList){
    let myMap: any = {};
    if(!myList || myList.length===0) return;

    for(let i=0; i<myList.length; i++){
      myMap[myList[i].value] = myList[i].name;
    }
    return myMap;
  }

  //Lookup function to retrieve RT value from a array
  lookupValueInRT(arr, val){
    if(!arr) return;

    for(let i=0; i<arr.length; i++){
      if(arr[i]["value"] === val){
        return arr[i]["name"];
      }
    }

    return '';
  }

  //Function to create native Hash Map from Array
  createReverseNativeMapFromList(myList){
    let myMap: any = {};
    if(!myList || myList.length===0) return;

    for(let i=0; i<myList.length; i++){
      myMap[myList[i].name] = myList[i].value;
    }
    return myMap;
  }

  sortObjectsByProperty(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a,b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  sortObjectsByStringProperty(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a,b) {
      var result = (a[property].toLowerCase() < b[property].toLowerCase()) ? -1 : (a[property].toLowerCase() > b[property].toLowerCase()) ? 1 : 0;
      return result * sortOrder;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/Utility/CommonUtility.ts